// 部门
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("department") || ""
}

const getters = {
  getDepartment:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("department",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("department")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
